import { Route, Routes } from "react-router-dom";
import Home from "../pages/home/Home";
import DetailProduct from "../pages/detailProduct/DetailProduct";
import Product from "../pages/product/Product";
import LatestOffer from "../pages/latestOffer/LatestOffer";
import DetailOffer from "../pages/detailOffer/DetailOffer";
import AboutCompany from "../pages/aboutCompany/AboutCompany";
import InformationAndNews from "../pages/informationAndNews/InformationAndNews";
import DetailInformationAndNews from "../pages/detailInformationAndNews/DetailInformationAndNews";
import Auction from "../pages/auction/Acution";
import Carier from "../pages/carier/Carier";
import DetailCarier from "../pages/detailCarier/DetailCarier";
import PageNotFound from "../pages/404/404";
import Laporan from "../pages/laporan/Laporan";
import MediaEducation from "../pages/mediaEducation/MediaEducation";
import DetailMediaEducation from "../pages/detailMediaEducation/DetailMediaEducation";
import SecurityInformation from "../pages/securityInformasi/SecurityInformation";
import Gallery from "../pages/gallery/Gallery";
import Riplay from "../pages/riplay/Riplay";
import Pengaduan from "../pages/pengaduan/Pengaduan";

export default function AppRoute() {
    return (
        <Routes>
            <Route path="/" element={<Home></Home>}></Route>
            <Route path="/produk" element={<Product></Product>}></Route>
            <Route path="/detail-produk/:name" element={<DetailProduct></DetailProduct>}></Route>
            <Route path="/penawaran-terkini" element={<LatestOffer></LatestOffer>}></Route>
            <Route path="/detail-penawaran-terkini/:name" element={<DetailOffer></DetailOffer>}></Route>
            <Route path="/tentang-kami" element={<AboutCompany></AboutCompany>}></Route>
            <Route path="/informasi-dan-berita" element={<InformationAndNews></InformationAndNews>}></Route>
            <Route path="/detail-informasi-dan-berita/:name" element={<DetailInformationAndNews></DetailInformationAndNews>}></Route>
            <Route path="/lelang" element={<Auction></Auction>}></Route>
            <Route path="/karir" element={<Carier></Carier>}></Route>
            <Route path="/detail-karir/:name" element={<DetailCarier></DetailCarier>}></Route>
            <Route path="/dokumen/laporan-publikasi" element={<Laporan></Laporan>}></Route>
            <Route path="/dokumen/kebijakan-keamanan-informasi" element={<SecurityInformation></SecurityInformation>}></Route>
            <Route path="/dokumen/dokumen-lainnya" element={<Riplay></Riplay>}></Route>
            <Route path="/media-edukasi" element={<MediaEducation></MediaEducation>}></Route>
            <Route path="/detail-media-edukasi/:name" element={<DetailMediaEducation></DetailMediaEducation>}></Route>
            <Route path="/galeri" element={<Gallery></Gallery>}></Route>
            <Route path="/pengaduan" element={<Pengaduan></Pengaduan>}></Route>
            <Route path="*" element={<PageNotFound></PageNotFound>}></Route>
        </Routes>
    )
}